import {
  CLIENT_APPLY_CART_PROMOTION_API,
  CLIENT_APPLY_MULTIPLE_PROMOTION_CART_API,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  CartPromotionRequestModel,
  CartPromotionModel,
} from "./cart-promotion.models";
import {ApplyPromotionRequestModel} from "../promotion/promotion.models";

export const applyCartPromotionAPI = async (model: CartPromotionRequestModel) => {
  return await apiClient.postHttp<CartPromotionModel>(
    `${CLIENT_APPLY_CART_PROMOTION_API}`,
    model
  );
};

export const applyMultiplePromotionCartAPI = async (model: ApplyPromotionRequestModel) => {
  return await apiClient.postHttp<CartPromotionModel[]>(
      `${CLIENT_APPLY_MULTIPLE_PROMOTION_CART_API}`,
      model
  );
};
